import React from 'react'
import cover from './cover.svg'
import CFImage from './CF.jpg'
import PMImage from './PM.jpg'
import {Accordion} from './accordion'

export class BookDescription extends React.Component {
  state = {active: "accordion-1"}

  setActive = (id) => {
    this.setState({active: id})
  }

  render() {
    return <div className="container grid-lg">
      <div className="columns">
        <div className="column col-6 col-sm-12 mb-2 mt-2">
          <img src={cover} className='ndnr-book-image' alt="„Das Netzwerk der Neuen Rechten“ im Rowohlt Verlag" />
        </div>
        <div className="column col-6 col-sm-12 mb-2 mt-2">
          <Accordion title="Das Buch" setActive={this.setActive} active={this.state.active} id="accordion-1">
            <p>
              Fast unbemerkt von der Öffentlichkeit ist im vergangenen Jahrzehnt
              eine „patriotische Parallelgesellschaft“ in Deutschland entstanden.
              Ein neues und einflussreiches neurechtes Netzwerk aus mehr als 180
              Stiftungen, Vereinen, Medien und Kampagnen ist herangewachsen.
              Eine Gegenkultur mit Jugendbewegung, Frauenbewegung, Gewerkschaft,
              Flüchtlingshilfsorganisation, Künstler*innen, Hipstermagazin,
              Modelabels, Trollarmeen im Netz, Parteien und sogar einem eigenen Bier.
            </p>
            <p>
              Seit Jahren spüren wir ihm nach: seinen öffentlichen Seiten und
              denen, die im Dunkeln liegen. Parallel zu dieser Webseite
              ist unser Report <BookLink>„Das Netzwerk der Neuen Rechten“ im Rowohlt
              Verlag</BookLink> erschienen. In dem Buch enthüllen wir erstmals das Ausmaß und die ganze Breite
              des Milieus - seine ideologischen Grundlagen, seine führenden
              Köpfe, seine wichtigen Zeitschriften, Verlage, Internet-Plattformen,
              Burschenschaften und Finanziers.
            </p>
            <p>
              Und wir erklären die Aktionsformen
              und Strategien der Szene, zeigen die engen Kontakte zur AfD auf,
              wie die Strömung international vernetzt ist und wie sie den
              Anschluss an die gesellschaftliche Mitte sucht.
            </p>
            <p>
              <BookLink>Hier können Sie „Das Netzwerk der Neuen Rechten“ bestellen.</BookLink> Wir
              empfehlen aber den Kauf beim Buchhändler Ihres Vertrauens.
            </p>
          </Accordion>

          <Accordion title="Pressestimmen" setActive={this.setActive} active={this.state.active} id="accordion-2">
            <p>
              "Fuchs und Middelhoff decken das Beziehungsgeflecht auf."
              <br/>
              (titel thesen temperamente, ARD)
            </p>

            <p>
              "Das Buch hat mich aufgewühlt. Noch nie habe ich die Neue Rechte besser verstanden."
              <br/>
              (Krautreporter)
            </p>

            <p>
              "Ein lesenswerter Überblick über die verwobenen Netzwerke untereinander."
              <br/>
              (Deutschlandfunk Kultur)
            </p>

            <p>
              "Das ist sehr gut: "Das Netzwerk der Neuen Rechten", auch lesen.
              Da regen sie sich gerade wahnsinnig drüber auf und das ist immer
              ein gutes Prädikat für Bücher dieser Art."
              <br/>
              (Klaas Heufer-Umlauf, Pro7)
            </p>


            <p>
              "Das Buch von Middelhoff und Fuchs ist lesenswert und wichtig ... spannend und gut zu lesen"
              <br/>
              (NDRinfo)
            </p>

            <p>
              "Fuchs und Middelhoff haben jahrelang recherchiert und überall in Deutschland fast 150 neurechte Organisationen ausgemacht, die untereinander stark vernetzt sind."
              <br/>
              (VICE)
            </p>

            <p>
              "Zwei sehr kompetente Journalisten ... wer sich einen Überblick verschaffen will, für den ist es echt super."
              <br/>
              (MDR Sputnik)
            </p>

            <p>
              "Sehr aufschlussreich ... ich kann Ihnen das Buch nur wärmstens ans Herz legen, es leistet im besten Sinne Aufklärungsarbeit und kommentiert auf kluge Weise das Zeitgeschehen."
              <br/>
              (Deutschlandfunk, Büchermarkt)
            </p>

            <p>
              "Christian Fuchs und Paul Middelhoff sind tief eingetaucht in das Milieu. Sie belegen in ihrem Buch, in welchem Ausmaß rechte und rechtsradikale Parteien und Bewegungen und ihre publizistischen Helfer in der Bundesrepublik die politische und mediale Agenda bestimmen."
              <br/>
              (Süddeutsche Zeitung)
            </p>

            <p>
              "Das Buch entlarvt das Netzwerk der Neuen Rechten als das, was es ist: gefährlich, engmaschig, dynamisch. Eine kleine grölende Parallelgesellschaft."
              <br/>
              (WDR, Westart)
            </p>

            <p>
              "Eminent wichtige Veröffentlichung"
              <br/>
              (taz)
            </p>

            <p>
              "Ein Grossreport ... sehr gelungene Mischung aus Recherchen, Reportagen und Analysen."
              <br/>
              (WOZ - Wochenzeitung, Schweiz)
            </p>
          </Accordion>

          <Accordion title="Die Autoren" setActive={this.setActive} active={this.state.active} id="accordion-3">
            <p className="text-justify">
              Wir sind <CF>Christian Fuchs</CF> und <PM>Paul Middelhoff</PM> und
              arbeiten für die Wochenzeitung <i>DIE ZEIT</i>. Seit Jahren beschäftigen
              wir uns mit dem Phänomen der Neue Rechten. Für das Buch sind wir durch
              Deutschland und Europa gereist und haben die wichtigsten Protagonist*innen der Szene getroffen.
            </p>
            <p>
              Wir haben Trumps Ex-Berater Steve Bannon in Budapest und Prag begleitet,
              haben mit einem der wichtigsten AfD-Finanziers nachts an einer Hotelbar
              in der hessischen Provinz gezecht, haben <i>Compact</i>-Chefredakteur
              Jürgen Elsässer zu einem seiner ersten Interviews mit den „Mainstreammedien“
              getroffen, waren geheimen Spendern in der Schweiz auf der Spur und mit einem
              AfD-Politiker in Serbien unterwegs.
            </p>
            <p>
              Wir hatten Zutritt zum Haus der Identitären Bewegung, waren auf einem Festival
              der Guerilla-Aktivist*innen und trafen den Chef von Deutschlands erfolgreichster
              Hetzseite zum Gespräch in dessen Küche. Während der Recherchen wurden wir bedroht,
              angelogen und gerieten in den Shitstorm einer rechten Trollarmee.
            </p>

            <a href='https://twitter.com/ChristianFuchs_'><img src={CFImage} height='150px' alt='Christian Fuchs'/></a>
            <a href='https://twitter.com/PaulMiddelhoff'><img src={PMImage} height='150px' alt='Paul Middelhoff' className='ml-2' /></a>
          </Accordion>

          <Accordion title="Mitmachen" setActive={this.setActive} active={this.state.active} id="accordion-4">
            <p>
              Haben wir eine Institution oder eine Verbindung vergessen, ist ein Eintrag veraltet? Bitte
              schreiben Sie uns: netzwerkneuerechte[at]gmail.com.
            </p>
          </Accordion>
        </div>
      </div>
    </div>
  }
}

const BookLink = (props) => <a href="https://www.rowohlt.de/paperback/christian-fuchs-das-netzwerk-der-neuen-rechten.html" target="_blank" rel="noopener noreferrer">{props.children}</a>

const CF = (props) => <a href="https://de.wikipedia.org/wiki/Christian_Fuchs_(Journalist)" target="_blank" rel="noopener noreferrer">{props.children}</a>
const PM = (props) => <a href="https://www.zeit.de/autoren/M/Paul_Middelhoff/index" target="_blank" rel="noopener noreferrer">{props.children}</a>



// WEBPACK FOOTER //
// ./src/book_description.js